<popup header="{{'服務總覽'|i18n:'chm00001759':null}}" [(visible)]="display" modal="modal" width="900" responsive="true"
    (onShow)="onShow()" (onHide)="onHide()" height="580" [system]="true">
    <div class="modal_area" *ngIf="viewForm">

        <div class="modal_area ESB_sitemap">
            <table class="tb_sin mar_top20" border="0" cellpadding="0" cellspacing="0" width="100%">
                <tbody>
                    <tr>
                        <td width="20%" class="hd">{{'區域'|i18n:'chm00005627':null}}</td>
                        <td width="80%" *ngIf="viewForm.areaCombo">
                            <dropdown [(ngModel)]="viewForm.selectArea" (onChange)="doChangeWebMenuNode($event)"
                                [combo]="viewForm.areaCombo"></dropdown>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="sitemap_section" *ngIf="viewForm.currentMenuNode">

                <ng-container *ngFor="let webMenuNode of viewForm.currentMenuNode.children; let i=index">

                    <div class="section_header">
                        <h1 class="header_title">{{webMenuNode.menuName}}</h1>
                    </div>
                    <div class="section_content">
                        <ng-container *ngFor="let menuNode of webMenuNode.children;let rowIndex=index">
                            <h2 [ngClass]="{'content_title':true,'mar_top20':rowIndex==0}">{{menuNode.menuName}}</h2>
                            <ul class="content_list">
                                <li class="content_item" *ngFor="let menu of menuNode.children">
                                    <a href="#"
                                        [ngClass]="{'item-link':true,'close-dialog':menu.permission,'disabled':!menu.permission}"
                                        (click)="toggleSubMainMenu($event,menu)">
                                        <i class="fa fa-caret-right"></i>
                                        <span>{{menu.menuName}}</span>
                                    </a>
                                </li>
                            </ul>
                        </ng-container>
                    </div>
                    <BR />

                </ng-container>

            </div>

        </div>

    </div>

    <p-footer>
        <div class="btn_box">
            <commandButton [mask]="false" (onClick)="onHide()">{{'關閉'|i18n:'common00001449':null}}</commandButton>
        </div>
    </p-footer>
</popup>